import React from 'react';
import styled from 'styled-components';
import hunnyLogo from 'assets/images/hunny-logo.png';
import { Trans } from 'react-i18next';

const BuyHunnyButton: React.FC<{ includeIcon?: boolean }> = ({ includeIcon }) => {
	return (
		<StyleTextButton
			href={`https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0x565b72163f17849832a692a3c5928cc502f46d69`}
			target={'_blank'}
			className="hunnybutton__content"
		>
			{includeIcon && <img src={hunnyLogo} style={{ width: 26 }} />}
			<StyledBalanceInfo>
				<StyleTextButton>
					<Trans>Buy now</Trans>
				</StyleTextButton>
			</StyledBalanceInfo>
		</StyleTextButton>
	);
};

const StyleTextButton = styled.a`
	margin-left: ${(props) => props.theme.spacing[1]}px;
	cursor: pointer;
	text-decoration: underline;

	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 16px;
	font-weight: 700;
	color: ${(props) => props.theme.color.purple[200]};
	text-shadow: 0 0 12px ${(props) => props.theme.color.purple[200]};
`;

const StyledBalanceInfo = styled.span`
	padding: 14px 8px;

	@media (max-width: 425px) {
		line-height: 0;
		max-width: 80px;
		min-width: 65px;
		padding: 0;

		& > a {
			font-size: 13px;
		}
	}
`;

export default BuyHunnyButton;
